<template>
    <div>
        <p v-if="errorMessage" style="color: red; margin-bottom: 8px;">
            {{ errorMessage }}
        </p>

        <div id="stripe-payment-element" />
    </div>
</template>

<script>
import { buildStripeAppearance } from '@/utils/stripeAppearance.util';
import { loadStripe } from '@stripe/stripe-js';

export default {
    props: {
        clientSecret: {
            type: String,
            required: true,
        },
        sessionKey: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            stripe: null,
            elements: null,
            errorMessage: null,
            isSubmitting: false,
        };
    },
    async mounted() {
        this.stripe = await loadStripe(this.sessionKey);
        if (!this.stripe) return;

        this.elements = this.stripe.elements({ clientSecret: this.clientSecret, appearance: buildStripeAppearance() });
        const paymentElement = this.elements.create('payment', { layout: { type: 'tabs' }, wallets: { link: 'never' } });

        paymentElement.mount('#stripe-payment-element');

        this.$el.parentElement.addEventListener('stripe-submit', this.handleSubmit);
    },

    beforeDestroy() {
        this.$el.parentElement?.removeEventListener('stripe-submit', this.handleSubmit);
    },

    methods: {
        async handleSubmit() {
            if (!this.elements || this.isSubmitting) return;

            this.isSubmitting = true;
            this.errorMessage = null;

            let setupIntent;

            try {
                setupIntent = await this.confirmStripeSetup();
            } catch (error) {
                this.errorMessage = error?.message
                        || 'An error occurred while confirming your payment method. Please try again.';
                this.isSubmitting = false;

                return;
            }

            Infusion.Ecomm.Invoice.InvoicePayment.showOrHideProcessingSpinner(true);

            const configField = document.getElementById('paymentMethodConfigId');
            const idField = document.getElementById('paymentMethodId');

            if (configField) configField.value = setupIntent.id;
            if (idField) idField.value = setupIntent.payment_method;

            const form = document.getElementById('invoicePaymentForm');

            if (form) form.submit();
        },

        async confirmStripeSetup() {
            const { error: submitError } = await this.elements.submit();

            if (submitError) throw new Error(submitError.message);

            const { setupIntent, error: confirmError } = await this.stripe.confirmSetup({
                elements: this.elements,
                redirect: 'if_required',
                confirmParams: { return_url: window.location.href },
            });

            if (confirmError) throw new Error(confirmError.message);

            return setupIntent;
        },
    }
}
</script>
